import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<{ [key: string]: boolean }>({});
  loading$ = this.loadingSubject.asObservable();

  setLoading(key: string, isLoading: boolean) {
    const current = this.loadingSubject.value;
    this.loadingSubject.next({ ...current, [key]: isLoading });
  }

  isLoading(key: string): boolean {
    return this.loadingSubject.value[key] || false;
  }
}